<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1" id="atn">AUTHOR’S NOTE</h1>
<p class="nonindent">In this novel I have made certain assumptions about the maximum size of various marine animals which may be challenged by some biologists. I do not think, however, that they will meet much criticism from underwater explorers, who have often encountered fish <em>several times</em> the size of the largest recorded specimens.</p>
<p class="indent">For an account of Heron Island as it is today, seventy-five years before the opening of this story, I refer the reader to <em>The Coast of Coral</em>, and I hope that the University of Queensland will appreciate my slight extrapolation of its existing facilities.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795325090_epub_atn_r1.vue?77a9ff0f